import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {UserService} from '../../core/services/user.service';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
// import {UserData} from '../../core/domain/user.domain';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {HttpService} from '../../core';
import {GlobalEvent} from '../../observe/globalnew.state';
import {environment} from '../../../environments/environment';
import {EncryptService} from '../../core';
import {MatTabGroup} from '@angular/material/tabs';
import {finalize} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {
  EmailVerificationComponent
} from "../../shared/components/dialog/email-verification/email-verification.component";
import {ToastrService} from "ngx-toastr";

declare var Intercom: any;
declare let window: any;

/**
 * @class LoginComponent
 * @description The component set the layout and logic for login page
 */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterViewInit {
  public email: string;
  public password: string;
  public signUpDeveloperForm: FormGroup;
  form: any;
  // subscribeEmail: string;
  submitted = false;
  tabIndex = 0;
  isSignUpDeveloper = false;
  isLoading: boolean;
  emailAddress: string;
  isDeactivated: boolean;
  isEmailOrPasswordIncorrect: boolean;
  noCompany: boolean;
  notAuthorized: boolean;
  customerUrl = environment.customerUrl;
  // isEmailEmpty: boolean;
  @ViewChild('loginForm') private loginForm: any;
  @ViewChild(MatTabGroup) matTabGroup: MatTabGroup;

  constructor(
    private userService: UserService,
    private fb: FormBuilder,
    private httpService: HttpService,
    private gl$: GlobalEvent,
    private router: Router,
    private encryptService: EncryptService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private toast: ToastrService
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
    this.signUpDeveloperForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.gl$.subscribe('CODE', 'CODE', (item: any) => {
      if (item == '401') {
        this.isLoading = false;

        this.isDeactivated = false;
        this.isEmailOrPasswordIncorrect = true;
        this.noCompany = false;
        this.notAuthorized = false;
      }
    });
    this.route.queryParamMap
      .subscribe((p: ParamMap) => {
        if (p.has('activateTab') && p.get('activateTab') === 'agent') {
          this.selectAgentTab();
        }
      });
    this.route.queryParamMap.subscribe((p: ParamMap) => {
      if (p.get('signUp') === 'true') {
        this.isSignUpDeveloper = true;
      }
    });
  }

  ngAfterViewInit(): void {
  }

  selectAgentTab(): void {
    setTimeout(() => {
      this.matTabGroup.selectedIndex = 1;
    }, 0);
  }

  get f() {
    return this.form.controls;
  }

  selectChange(event: any) {
    this.isEmailOrPasswordIncorrect = false;
    this.tabIndex = event.index;
    this.isSignUpDeveloper = false;
  }

  login() {

    this.submitted = true;
    if (this.form.invalid) {
      return;
    }


    this.isLoading = true;
    this.isDeactivated = false;
    this.isEmailOrPasswordIncorrect = false;
    this.noCompany = false;
    this.notAuthorized = false;
    const fd = new FormData();
    fd.append('username', this.trim(this.form.get('email').value));
    fd.append('password', this.form.get('password').value);
    fd.append('grant_type', 'password');
    fd.append('terminal_type', this.tabIndex === 0 ? 'DEVELOPER' : 'AGENT');

    this.userService.login(fd)
      .pipe(finalize(() => {
        this.isLoading = false;
        this.submitted = false;
      }))
      .subscribe((res) => {
        console.log(res, 'res.code');
        if (res.code === 1) {
          console.log('Login successful');
          if (this.tabIndex === 1) {
            const loginData = {
              email: this.trim(this.form.get('email').value),
              password: this.form.get('password').value
            };
            window.sa_event('agent_login', {
              email: loginData.email,
            });
            const loginStr = this.encryptService.encryptUsingAES128(JSON.stringify(loginData), '8c18266c4e8fa5de');
            console.log(loginStr);
            window.location.href = environment.agentUrl + '/auth/login?login=' + encodeURIComponent(loginStr);
            return;
          }

          window.sa_event('developer_login', {
            email: this.trim(this.form.get('email').value),
          });
          this.userService.getInfo().subscribe((retUser: any) => {
            console.log('retUser', retUser);
            if (retUser) {
              // heap analytics
              window.heap?.identify(retUser.data?.id);
              window.heap?.addUserProperties({
                role: retUser.data?.roles[0]?.role,
                email: retUser.data?.email,
                first_name: retUser.data?.firstName,
                last_name: retUser.data?.lastName,
                company_id: retUser.data?.company?.id,
                company_name: retUser.data?.company?.name,
              });
              this.router.navigate(['/projects']);
            }
          });
        } else if (res.code === 0) {
          this.isDeactivated = true;
        } else if (res.code === -4) {
          this.isEmailOrPasswordIncorrect = true;
        } else if (res.code === -5) {
          this.noCompany = true;
        } else if (res.code === -9) {
          this.notAuthorized = true;
        }
      });
  }

  // 去掉前后空格
  trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, '');
  }

  toYepIo() {
    window.open(environment.devUrl + '/auth/home', '_self');
  }

  // contactUs() {
  //   window.sa_event('contact_us', {});
  //   Intercom('showNewMessage');
  // }

  // toDemo() {
  //   window.sa_event('book_demo', {});
  //   Intercom('showNewMessage');
  // }
  onCreateAccount() {
    this.isLoading = true;
    const formData = this.prepareFormData();
    this.signUp(formData);
  }

  prepareFormData() {
    const formData = new FormData();
    formData.append('email', this.signUpDeveloperForm.get('email').value);
    formData.append('password', this.signUpDeveloperForm.get('password').value);
    formData.append('terminal_type', 'DEVELOPER');
    return formData;
  }

  signUp(formData: any) {
    if (this.signUpDeveloperForm.invalid) {
      this.toast.error('Please enter valid email and password.');
      this.isLoading = false;
      return;
    }
    this.httpService.signUp(formData)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe(res => this.handleResponse(res));
  }

  handleResponse(res: any) {
    if (res.code === 1) {
      this.emailAddress = res.data.contacts[0].content;
      this.openEmailVerificationDialog();
      this.signUpDeveloperForm.reset();
    } else {
      this.toast.error('Sign up failed, please try again later.');
    }
  }

  openEmailVerificationDialog() {
    const dialogRef = this.dialog.open(EmailVerificationComponent, {
      minWidth: '300px',
      width: '80%',
      maxWidth: '500px',
      data: {record: this.emailAddress}
    });
  }
}
